export enum BasedOnOptions {
    Unspecified = "-",
    Woz = "woz",
    Valuation = "valuation",
    RemoteValuation = "remotevaluation",
    Other = "other"
}
